import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, ModuleFE_Thunderstorm, mouseInteractivity_PopUp, Thunder, } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '../../../../icons/index.js';
import './Component_EditorHeader.scss';
export const viewMode_View = 'view';
export const viewMode_Edit = 'edit';
export class Component_EditorHeader extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.searchItem = nextProps.searchItem;
        state.editMode = !!nextProps.editMode;
        state.itemActions = nextProps.itemActions ?? [];
        state.editModeActions = nextProps.editModeActions ?? [];
        return state;
    }
    // ######################## Logic ########################
    openItemActions = (e) => {
        const box = e.currentTarget.getBoundingClientRect();
        const model = {
            id: 'editor-header__item-actions',
            originPos: { x: box.right, y: box.y + (box.height / 2) },
            modalPos: { x: 1, y: 1 },
            content: () => {
                return this.state.itemActions.map((action, index) => {
                    return _jsx(Button, { variant: 'text', onClick: async () => {
                            await action.action();
                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        }, children: action.label }, index);
                });
            },
            offset: { x: 5, y: -(box.height / 2) }
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_H_C, { className: 'editor-header', children: [this.renderTitle(), this.renderItemActions(), this.renderEditModeActions()] });
    }
    renderTitle = () => {
        const item = this.state.editable.item;
        const searchItem = this.state.searchItem;
        let label;
        const localEnv = Thunder.getInstance().getConfig().label?.toLowerCase() === 'local';
        if (!item._id)
            label = `New ${searchItem.entityLabel}`;
        else
            label = `${searchItem.mapper(item)}${localEnv ? ` (${item._id})` : ''}`;
        return _jsxs(LL_V_L, { className: 'editor-header__title', onClick: () => {
                if (localEnv && item._id)
                    ModuleFE_Thunderstorm.copyToClipboard(item._id);
            }, children: [_jsx("div", { className: 'editor-header__title__label', children: label }), _jsxs(LL_H_C, { className: 'editor-header__title__hierarchy', children: [_jsx("span", { className: 'editor-header__title__hierarchy__entity', children: searchItem.entityLabel }), "in", _jsx("span", { className: 'editor-header__title__hierarchy__group', children: searchItem.groupId })] })] });
    };
    renderItemActions = () => {
        if (this.state.editMode || !this.state.itemActions.length)
            return;
        return _jsx(ICONS.more.component, { onClick: this.openItemActions });
    };
    renderEditModeActions = () => {
        if (!this.state.editMode || !this.state.editModeActions.length)
            return;
        return _jsx(LL_H_C, { className: 'editor-header__edit-mode-actions', children: this.state.editModeActions.map((action, index) => {
                return _jsx(Button, { variant: 'primary', onClick: action.action, children: action.label }, index);
            }) });
    };
}
//# sourceMappingURL=Component_EditorHeader.js.map